var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSwap(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M7.933 13.724L5.52 16.076h14.033c.25 0 .447.19.447.432s-.197.432-.447.432H5.52l2.413 2.334c.179.173.179.45 0 .605-.09.086-.197.121-.322.121s-.232-.035-.322-.121l-3.164-3.06c-.09-.086-.125-.19-.125-.311s.054-.225.125-.311l3.182-3.078c.179-.172.465-.172.626 0 .179.173.179.45 0 .605zM4 7.518c0 .242.197.432.447.432H18.48l-2.43 2.351c-.18.173-.18.45 0 .606.089.086.196.12.32.12.126 0 .233-.034.323-.12l3.164-3.078c.09-.086.125-.19.125-.31 0-.122-.054-.226-.125-.312L16.675 4.13c-.179-.173-.465-.173-.626 0-.179.173-.179.45 0 .605l2.414 2.334H4.447c-.25.017-.447.207-.447.45z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwap);
export default __webpack_public_path__ + "static/media/swap.fda16e520afd3316ed8d9353147a3471.svg";
export { ForwardRef as ReactComponent };